import user from './images/user.png';
import wallet from './images/wallet.png';
import bannerTop from './images/banner-top.png';
import shoeImg from './images/banner-img1.png'
import cloudImg from './images/banner-img2.png'
import animalImg from './images/banner-img3.png'
import github from './images/gitHub.png';
import reddit from './images/reddit.png';
import send from './images/send.png';
import mvector from './images/m-vector.png';
import topright1 from './images/top-right1.png';
import topright2 from './images/top-right2.png';
import picture from './images/image.png';
import lightbulb from './images/light-bulb.png';
import pricetag from './images/price-tag.png';
import setting from './images/setting.png';
import pathtop from './images/path-top.png';
import leftarrow from './images/left-arrow.png';
import rightarrow from './images/right-arrow.png';
import slider1 from './images/slider1.png';
import slider2 from './images/slider2.png';
import slider3 from './images/slider3.png';
import leftarrow1 from './images/left-arrow-2.png';
import rightarrow1 from './images/right-arrow-2.png';
import dropdownicon from './images/dropdown-icon.png';
import card1 from './images/card1.png';
import instagram from './images/insta.png';
import youtube from './images/youtube.png';
import discord from './images/discord.png';
import twitter from './images/twitter.png';
import card2 from './images/card2.png';
import card3 from './images/card3.png';
import card4 from './images/card4.png';
import card5 from './images/card5.png';
import card6 from './images/card6.png';
import bannerimg1 from './images/banner-img1.png'
import bannerimg2 from './images/banner-img2.png'
import bannerimg3 from './images/banner-img3.png'

export const Images = {
    user,
    bannerimg1,
    bannerimg2,
    bannerimg3,
    wallet,
    card3,
    card4,
    card5,
    card6,
    card2,
    bannerTop,
    shoeImg,
    cloudImg,
    animalImg,
    github,
    reddit,
    send,
    mvector,
    topright1,
    topright2,
    picture,
    lightbulb,
    pricetag,
    setting,
    pathtop,
    leftarrow,
    rightarrow,
    slider1,
    slider2,
    slider3,
    leftarrow1,
    rightarrow1,
    dropdownicon,
    card1,
    twitter,
    instagram,
    discord,
    youtube,
};